export const points = [
  {
    name: "10x Potions",
    logo: "/points/potions.png",
    collateralVaults: ["0xA45189636c04388ADBb4D865100DD155e55682EC"],
  },
  {
    name: "3x Potions",
    logo: "/points/potions.png",
    collateralVaults: ["0xFECebF56f150A68dDd197c3a6101da35C46693Ac"],
  },
  {
    name: "10x Potions",
    logo: "/points/potions.png",
    collateralVaults: ["0xe1E549C965A4A0514D9bf80161D32924b8694822"],
  },
  {
    name: "3x Potions",
    logo: "/points/potions.png",
    collateralVaults: ["0xb9CC370a8f19322FC4BF69Da80c6C39FF8F2dB90"],
  },
  {
    name: "earn 10 XSY Points per 1$ per day",
    logo: "/points/xsy-points.png",
    collateralVaults: ["0x902714C7661697c873C76dEC426b63B2593ecc0a"],
  },
] as const
